function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 12.6c0 .4.2.7.7.7.3 0 .7-.3.7-.7V7c0-.4-.3-.7-.7-.7s-.7.3-.7.7zm4.1-3.1c.2-.3.7-.3.9 0 1.4 1.4 1.9 3.2 1.9 4.5s-.5 3-1.9 4.4c-1.3 1.4-3.1 1.9-4.3 1.9-1.3 0-3-.5-4.4-1.9-1.3-1.4-1.8-3.2-1.8-4.5s.5-3 1.8-4.4c.2-.3.8-.3 1 0s.2.7 0 1c-1.1 1.1-1.4 2.4-1.4 3.4s.3 2.4 1.4 3.5 2.4 1.4 3.4 1.4c.9 0 2.3-.4 3.4-1.4 1.1-1.1 1.4-2.4 1.4-3.4s-.3-2.4-1.4-3.5c-.2-.3-.2-.8 0-1",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgLogout;